/* eslint-disable react/react-in-jsx-scope */
import { buttonVariants } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/libs/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PerformanceSkeleton } from "./PerformanceSkeleton";

const TabPerformanceSkeleton = () => {
  return (
    <div>
      <div className=" flex justify-between pr-5 mb-4">
        <div
          className={cn(
            buttonVariants({ variant: "outline" }),
            "px-3 text-[10px] text-[#D3D3D3] hover:bg-transparent hover:text-[#D3D3D3]"
          )}
        >
          <Skeleton className="h-5 w-5 mr-2" />
          <Skeleton className="h-5 w-24" />
        </div>
        <div className="flex flex-row gap-4 justify-end items-center">
          <div className="flex py-3">
            <ChevronLeft className="text-foreground/70" />
            <ChevronRight className="text-foreground/70" />
          </div>
          <Skeleton className="w-[100px] h-4 rounded-[20px]" />
        </div>
      </div>
      <div className=" relative ml-[210px] flex flex-row gap-2 mr-10">
        {Array.from({ length: 12 }).map((_, index) => (
          <Skeleton
            className=" w-1/12 h-7 rounded-[5px] bg-[#ecedee]"
            key={index}
          />
        ))}
      </div>
      <div className="bg-[#F7F9FB] rounded-[20px]">
        <PerformanceSkeleton />
        <PerformanceSkeleton />
        <PerformanceSkeleton />
      </div>
    </div>
  );
};

export default TabPerformanceSkeleton;
